var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.description)?_c('meta',{attrs:{"name":"description","content":_vm.description}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a8dbf66","hasScoped":false,"buble":{"transforms":{}}}!./src/components/meta-description/template.html
// module id = 599
// module chunks = 0